module.exports = __webpack_public_path__ + "img/16.02ae7437.jpg";